import { render } from "./HermesPaymentRequests.vue?vue&type=template&id=4d0ddd64&scoped=true"
import script from "./HermesPaymentRequests.vue?vue&type=script&lang=js"
export * from "./HermesPaymentRequests.vue?vue&type=script&lang=js"

import "./HermesPaymentRequests.vue?vue&type=style&index=0&id=4d0ddd64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d0ddd64"]])

export default __exports__